export default __webpack_public_path__ + "static/1520-df8d48779b82fb966c1af1c310212fee.gif";